module.exports = __webpack_public_path__ + "img/office2_7-8-2021.03cba084.jpg";